module.exports = __webpack_public_path__ + "img/room_1.706a64e3.png";